import { Card } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

interface CliffNoteLoaderProps {
  isFetchingArticles: boolean;
  isGeneratingCliffNote: boolean;
  articleCount?: number;
  maxArticles?: number;
}

export default function CliffNoteLoader({
  isGeneratingCliffNote,
  articleCount,
  maxArticles,
}: CliffNoteLoaderProps) {
  return (
    <>
      <Card className="p-5 mt-4 border border-black bg-gradient-to-r from-indigo-100 to-purple-100 rounded-xl shadow-none">
        <div className="flex items-center gap-3">
          <Loader2 className="w-4 h-4 animate-spin text-purple-500" />
          <div className="text-sm font-medium text-gray-800">
            {isGeneratingCliffNote && (
              <div className="flex flex-col gap-0.5">
                <span className="text-black">Getting the gist...</span>
                <span className="text-xs text-gray-500">
                  Analyzing the first{" "}
                  {Math.min(articleCount || 0, maxArticles || 0)} articles
                </span>
              </div>
            )}
          </div>
        </div>
      </Card>
    </>
  );
}
